import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F002 {
  f002_01: string;  // 使用等級代碼
  f002_11: string;  // 等級名稱
}

export interface F004 {
  f004_01: string;  // 子系統代碼
  f004_11: string;  // 子系統名稱
  f004_14: number;  // 排序序號
}

export interface PermissionItem {
  f007_12: string;      // 程式代碼
  program_name: string; // 程式名稱
  category: string;     // 程式類別中文
  f007_15: boolean;     // 使用權
}

export interface PermissionListResponse {
  level_code: string;
  level_name: string;
  subsys_code: string;
  items: PermissionItem[];
}

export interface SavePermissionsRequest {
  level_code: string;
  subsys_code: string;
  items: { f007_12: string; f007_15: boolean }[];
}

export interface CopyPermissionsRequest {
  source_level: string;
  target_level: string;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const accessControlApi = {
  /** List all access levels (F002) */
  async listLevels(): Promise<{ data: F002[] }> {
    const res = await apiClient.get('/api/access-control/levels');
    return res.data;
  },

  /** Get a single level by code */
  async getLevel(code: string): Promise<F002> {
    const res = await apiClient.get(`/api/access-control/levels/${encodeURIComponent(code)}`);
    return res.data;
  },

  /** List all subsystems (F004) */
  async listSubsystems(): Promise<{ data: F004[] }> {
    const res = await apiClient.get('/api/access-control/subsystems');
    return res.data;
  },

  /** Get permissions grid for a level + subsystem */
  async getPermissions(levelCode: string, subsysCode: string): Promise<PermissionListResponse> {
    const res = await apiClient.get(
      `/api/access-control/permissions/${encodeURIComponent(levelCode)}/${encodeURIComponent(subsysCode)}`
    );
    return res.data;
  },

  /** Save permissions (BR-07) */
  async savePermissions(data: SavePermissionsRequest): Promise<{ message: string }> {
    const res = await apiClient.post('/api/access-control/permissions', data);
    return res.data;
  },

  /** Copy permissions from source to target level (BR-14) */
  async copyPermissions(data: CopyPermissionsRequest): Promise<{ message: string }> {
    const res = await apiClient.post('/api/access-control/copy', data);
    return res.data;
  },
};
